import { Popover, PopoverProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    popover: {
        padding: 24,
        overflow: 'visible',
        boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.26)',
        borderRadius: 4,

        '&::before, &::after': {
            top: '100%',
            left: '50%',
            border: 'solid transparent',
            content: '""',
            height: 0,
            width: 0,
            position: 'absolute',
            pointerEvents: 'none',
        },

        '&::before': {
            borderTopColor: 'rgb(255, 255, 255)',
            borderWidth: 10,
            marginLeft: '-10px',
        },

        marginBottom: '3rem',
    },
}));

export const PoolPopover = (props: PopoverProps) => {
    // hooks
    const classes = useStyles();

    return (
        <Popover
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            PaperProps={{ className: classes.popover }}
            {...props}
        />
    );
};
